var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"float-right d-none d-sm-block"},[_vm._v(" Desenvolvido pelo "),_c('a',{attrs:{"href":"http://nti.ufal.br","target":"_blank"}},[_vm._v("NTI")]),_vm._v(" da "),_c('a',{attrs:{"href":"https://ufal.br","target":"_blank"}},[_vm._v("UFAL")])])])
}]

export { render, staticRenderFns }